import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export function FAQ({ items }: { items: { question: string; answer: string }[] }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="grid gap-3">
      {items.map((item, index) => (
        <div key={item.question} className="overflow-hidden rounded-2xl border border-forest/10 bg-white shadow-sm">
          <button type="button" className="flex w-full items-center justify-between gap-4 p-5 text-left font-black text-ink" onClick={() => setOpen(open === index ? -1 : index)}>
            {item.question}
            <ChevronDown className={`h-5 w-5 shrink-0 transition ${open === index ? 'rotate-180' : ''}`} />
          </button>
          {open === index && <p className="border-t border-forest/10 px-5 pb-5 pt-4 leading-7 text-charcoal/70">{item.answer}</p>}
        </div>
      ))}
    </div>
  );
}
